import React, { useEffect, useState } from 'react';
import NavBar from '../../components/userHomeNavBar/navBar';
import SideBar from '../../components/userHomeSideBar/sideBar';
import EditProductCard from './editProductCard';  
import ReactLoading from 'react-loading'; 
import { useAuth } from '../../context/DBContext';  
import CreateProductModal from '../../components/modals/createProductModal';
import DeleteProductModal from '../../components/modals/deleteProductModal';
import EditProductModal from '../../components/modals/editProductModal';
import { Timestamp } from 'firebase/firestore';  
import { message } from 'antd';  // Ant Design message for success notification
import {
    LoadingOutlined,
  } from '@ant-design/icons';
  
import { Layout, Spin, Select } from 'antd';
const { Content } = Layout;

const AdminProductPage = () => {
    const { fetchProducts, createProduct, updateProduct, deleteProduct, uploadProductImage } = useAuth();  
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);  // State for submission loading
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [categories, setCategories] = useState([]);  // Add this state to track available categories
    const [newProduct, setNewProduct] = useState({ 
        name: '', 
        description: '', 
        link: '', 
        image: null, 
        category: [] // Change category to array for multiple tags
    });

    useEffect(() => {
        // Fetch products from Firebase when component loads
        const loadProducts = async () => {
            const fetchedProducts = await fetchProducts(); 
            setProducts(fetchedProducts);
            setLoading(false);
        };
        loadProducts();
    }, [fetchProducts]);

    const handleCreateProduct = async () => {
        try {
          setSubmitting(true);  // Start loading spinner
          let imageUrl = null;
    
          // If there's an image, upload it to Firebase Storage first
          if (newProduct.image) {
            imageUrl = await uploadProductImage(newProduct.image); // Use the upload function from context
          }
    
          // Create the product with the image URL (if available)
          const productData = {
            ...newProduct,
            image: imageUrl,  // Store the URL or null if no image
            created_at: Timestamp.now(),
            updated_at: Timestamp.now(),
          };
    
          await createProduct(productData);
          message.success('Product successfully uploaded!');  // Show success message
          
          // Reload products after successful creation
          const fetchedProducts = await fetchProducts();
          setProducts(fetchedProducts);

          setShowCreateModal(false);
          setNewProduct({ name: '', description: '', link: '', image: null, category: [] });  // Reset the form
        } catch (error) {
          console.error('Error creating product: ', error);
        } finally {
          setSubmitting(false);  // Stop loading spinner
        }
      };

    const handleUpdateProduct = async (updatedData) => {
        try {
            setSubmitting(true);
            let imageUrl = selectedProduct.image;

            // If there's a new image, upload it to Firebase Storage
            if (updatedData.imageFile) {
                imageUrl = await uploadProductImage(updatedData.imageFile);
            }

            // Update the product with the new data
            const productData = {
                name: updatedData.name,
                description: updatedData.description,
                link: updatedData.link,
                category: updatedData.category,
                image: imageUrl,
            };

            await updateProduct(selectedProduct.id, productData);
            message.success('Product successfully updated!');
            
            // Reload products after successful update
            const fetchedProducts = await fetchProducts();
            setProducts(fetchedProducts);

            setShowEditModal(false);
            setSelectedProduct(null);
        } catch (error) {
            console.error('Error updating product: ', error);
            message.error('Failed to update product');
        } finally {
            setSubmitting(false);
        }
    };

    const handleDeleteProduct = async () => {
        if (selectedProduct) {
            await deleteProduct(selectedProduct.id);  
            setShowDeleteModal(false);  
            setProducts(products.filter(product => product.id !== selectedProduct.id)); // Remove from UI
        }
    };

    return (
       
                        <section >

                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Product Manager
                            </h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <button
                                className="btn btn-primary btn-icon btn-round hidden-sm-down float-right m-l-10"
                                type="button"
                                onClick={() => setShowCreateModal(true)}
                            >
                                <i className="zmdi zmdi-upload" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Show loading animation while fetching products */}
                {loading ? (
                    <div className="flex justify-center items-center h-48">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                    </div>
                ) : (
                    <div className="container-fluid">
                        <div className="row clearfix">
                            {products.map(product => (
                                <EditProductCard
                                    key={product.id}
                                    productName={product.name}
                                    category={product.category}
                                    lastUpdated={product.lastUpdated}
                                    productLink={product.link}
                                    productImage={product.image} // Pass image URL to EditProductCard
                                    onEdit={() => {
                                        setSelectedProduct(product);
                                        setShowEditModal(true);
                                    }}
                                    onDelete={() => {
                                        setSelectedProduct(product);
                                        setShowDeleteModal(true);
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                )}

                {/* Modal for Creating Product */}
                <CreateProductModal 
                    show={showCreateModal} 
                    onClose={() => setShowCreateModal(false)} 
                    onCreate={handleCreateProduct} 
                    newProduct={newProduct}
                    setNewProduct={setNewProduct}
                    submitting={submitting}  // Pass submitting state to modal
                />

                {/* Modal for Deleting Product */}
                <DeleteProductModal 
                    show={showDeleteModal} 
                    onClose={() => setShowDeleteModal(false)} 
                    onDelete={handleDeleteProduct} 
                />

                {/* Modal for Editing Product */}
                <EditProductModal
                    show={showEditModal}
                    onClose={() => {
                        setShowEditModal(false);
                        setSelectedProduct(null);
                    }}
                    onUpdate={handleUpdateProduct}
                    product={selectedProduct}
                    submitting={submitting}
                />
            </section>
         
    );
};

export default AdminProductPage;
